import type { OpenTasksOpts, TaskInstance } from '../endpoints';
import getTaskPage from '../taskPage';
import readCompleteList from '../../readCompleteList';

const OPEN_STATUSES = ['pending', 'in_progress', 'overdue', 'scheduled'];

export default async function getOpenTasksForPatient(
  withingsUserId: string | number,
  opts: OpenTasksOpts = {},
): Promise<TaskInstance[]> {
  const uid = String(withingsUserId);
  const rows = await readCompleteList((limit) => getTaskPage({
    withings_user_id: uid,
    status: OPEN_STATUSES,
    assigned_to_type: opts.assignedToType,
    sort: 'created',
    order: 'asc',
    limit,
    offset: 0,
  }), (task) => {
    if (String(task.withings_user_id ?? '') !== uid) throw new Error('Open-task patient mismatch.');
    if (!OPEN_STATUSES.includes(String(task.status))) throw new Error('Open-task status changed while loading.');
    return String(task.task_id ?? '');
  });
  const now = Date.now();
  return opts.includeLatent ? rows : rows.filter((task) => {
    const available = Date.parse(String(task.available_at ?? ''));
    return !Number.isFinite(available) || available <= now;
  });
}
